// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1GsGV","colMaxWidth":"Table_colMaxWidth__3kj0Y"};